export const understandingChakras = {
    heading: "Understanding Chakras",
    content: [
        'Chakra” translates to “wheel” or “disk.”',
        'These refer to nodes in the body where physical, emotional, and spiritual energies meet.',
        'Chakras are spinning vortexes of energy aligning body, mind, and soul.',
        'There are many chakra points throughout the body, but focus is usually on the seven main chakras located along the spine.',
        'Alignment and balance of these chakras are crucial for overall well-being and harmony.',
    ],
}